import e from "./index89.js";
import t from "./index98.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createColorScheme.js
var n = [...Array(25)].map((e, n) => {
	if (n === 0) return "none";
	let r = t(n);
	return `linear-gradient(rgba(255 255 255 / ${r}), rgba(255 255 255 / ${r}))`;
});
function r(e) {
	return {
		inputPlaceholder: e === "dark" ? .5 : .42,
		inputUnderline: e === "dark" ? .7 : .42,
		switchTrackDisabled: e === "dark" ? .2 : .12,
		switchTrack: e === "dark" ? .3 : .38
	};
}
function i(e) {
	return e === "dark" ? n : [];
}
function a(t) {
	let { palette: n = { mode: "light" }, opacity: a, overlays: o, ...s } = t, c = e(n);
	return {
		palette: c,
		opacity: {
			...r(c.mode),
			...a
		},
		overlays: o || i(c.mode),
		...s
	};
}
//#endregion
export { a as default, r as getOpacity, i as getOverlays };

//# sourceMappingURL=index99.js.map